import { memo } from 'react';

import ExcelIconSVG from '@/assets/excel-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IExcelIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={ExcelIconSVG} {...props} />;

export const ExcelIcon = memo(IExcelIcon) as typeof IExcelIcon;
